export default __webpack_public_path__ + "static/media/txt2_pc@2x.8ace36a9.png";